import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import '../Common/styles/Charts.css';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { menus } from './Common/Consts/sidebar';
import Results from './Results/Results';
import Regulation from './Regulation/Regulation';
import { HomeNav } from '../Common/Home/HomeNav';
import Calls from './Calls/Calls';

function DashBoardSamu() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />
            <div className="dashboards-page">
                <HomeNav menus={menus} />
                <Routes>
                    <Route
                        path="/"
                        element={<Navigate to="results" replace />}
                    />
                    <Route
                        path="/results/*"
                        element={
                            <Results
                                dashboardPath={'dashboardsamu'}
                                menuPath={'results'}
                            />
                        }
                    />
                    <Route 
                        path="/regulation/*" 
                        element={
                            <Regulation 
                                dashboardPath={'dashboardsamu'} 
                                menuPath={'regulation'} 
                            />
                        } 
                    />
                    <Route 
                        path="/calls/*" 
                        element={
                            <Calls 
                                dashboardPath={'dashboardsamu'} 
                                menuPath={'calls'} 
                            />
                        } 
                    />
                </Routes>
            </div>
        </QueryClientProvider>
    );
}

export default DashBoardSamu;
